


    <section>
    <div class="viewdriver">
        <div class="crt">View Sub-Admin</div>
        <div class="close" (click)="closeDialog()"><mat-icon>close</mat-icon></div>
    <div class="details">
    
      <div class="div">
        <label class="label1">Name</label>
    <span class="span1">{{name}}</span>
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Email Id</label>
       <span class="span1">{{email}}</span>
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Phone Number:</label>
    <span class="span1">{{phoneNo}}</span>
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Module</label>
       <!-- <span class="span">{{VehicleType}}</span> -->
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Created On</label>
    <span class="span1">{{createdon | date: 'd/MM/y, h:mm:ss a'}}</span>
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Created By</label>
    <!-- <span class="span">{{vehicleName}}</span> -->
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Modified On:</label>
    <span class="span1">{{updatedAt}}</span>
      </div>
      <span class="line"></span>
      <div class="div">
        <label class="label1">Modified By</label>
       <!-- <span class="span">{{Rcvalidity}}</span> -->
      </div>
      <span class="line"></span>
    </div>
    
   
    
   
    <div class="close"><button class="button" (click)="closeDialog()">Okay</button></div>
    </div>
    </section>
  
    
    
    